export const LOGIN = 'LOGIN';
export const DEFAULT_ACTION = 'DEFAULT_ACTION';
export const LOG_OUT = "LOG_OUT";
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';